import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-queue-popup',
  templateUrl: './select-queue-popup.component.html',
  styleUrls: ['./select-queue-popup.component.scss']
})
export class SelectQueuePopupComponent implements OnInit {
  form: UntypedFormGroup;
  selectApiOptions: [];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<SelectQueuePopupComponent>,
    private translate: TranslateService
  ) {
    this.selectApiOptions = data;
  }

  ngOnInit() {
    console.log('this.selectApiOptions', this.selectApiOptions);
    this.initializeForm();
  }

  private initializeForm() {
    this.form = this.formBuilder.group({
      selectQueue: ['salesExportQueue']
    });
  }

  save() {
    // this.form.markAllAsTouched();
    console.log("this.form.get('selectQueue').value : ", this.form.get('selectQueue').value);
    console.log('this.form.valid : ', this.form.valid);
    if (this.form.valid) {
      this.dialogRef.close(this.form.get('selectQueue').value);
    }
  }
}
